// this is an autogenerated file from DesignSystem/TasksFilters/Board/Content/Content/Content/Boards/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_TasksFilters_Board_Content_Content_Content_Boards($board_ids: [uuid!]!) {
  tasks_boards(where: { id: { _in: $board_ids } }) {
    id
    name
  }
}

`